import dayjs from 'dayjs';

export const formatDateToString = (rawDate?: string | null, fallback = '--'): string => {
  return rawDate ? dayjs(rawDate).format('DD/MM/YYYY') : fallback;
};
